<template>
  <activity-po-wo-wrapper :rfqID="data.rfqID" :handleAutoSave="handleAutoSave">
    <template v-slot:default="{ autoSaveMiddleware }">
      <activity-review-form :data="data" :model="model" @onAutoSave="autoSaveMiddleware" @onDetails="handleDetails" />
    </template>
  </activity-po-wo-wrapper>
</template>

<script>
import { ServiceRepairExchangeOrderFollowUp } from '@/services/RepairExchangeOrderFollowUp'
export default {
  name: 'ActivityReview',
  components: {
    'activity-review-form': () => import(/* webpackChunkName: 'OpenPOReview' */ './ActivityReviewForm'),
    'activity-po-wo-wrapper': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/ActivityPoWoWrap/index')
  },
  props: {
    data: { type: Object, required: true },
    item: { type: Object, required: true },
    model: { type: Function, required: true },
    autoSave: { type: Function }
  },
  computed: {
    currentEmployee () {
      return this.$store.getters.get('currentEmployee')
    }
  },
  methods: {
    handleDetails () {
      this.$emit('onDetails', { id: this.data.id })
    },
    handleAutoSave (config) {
      const labelSelect = config.label
      const id = this.data.id
      this.autoSave(config)
        .then(({ e, config: { field, value } }) => {
          if (e) {
            return
          }
          this.handleUpdatedValue({ id, field, labelSelect, value })
        })
    },
    handleUpdatedValue ({ id, field, labelSelect, value }) {
      ServiceRepairExchangeOrderFollowUp
        .updateNotification({ id, field, labelSelect, value })
    }
  }
}
</script>
